import alertify from 'alertifyjs';
import axios from 'axios';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import DataTable from 'react-data-table-component';
import { apiRoutes } from '../../AppSettings';
import { AuthContext } from '../../contexts/AuthContext';
import Util from '../../Util';
import Breadcrumb from '../shared/Breadcrumb';
import SideNav from './shared/SideNav';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';

const SET_SERVICE = "SET_SERVICE"
const SET_POPUPTITLE = "SET_POPUPTITLE";

const customStyles = {
    title: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    rows: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    headCells: {
      style: {
        paddingLeft: '15px', // override the cell padding for head cells
        paddingRight: '15px',
        fontWeight: 'bold',
        fontSize: '15px'
      },
    },
    cells: {
      style: {
        paddingLeft: '15px', // override the cell padding for data cells
        paddingRight: '15px',
        paddingTop: '10px', // override the cell padding for data cells
        paddingBottom: '8px',
        fontSize: '15px',
      },
    },
  };

const initialValue = {
    title: 'Add',
    service: {
        serviceId: 0,
        name: "",
        cost: 0,
        description: ''
    }
}

const reducer = (state, action) => {
    switch(action.type)
    {
        case SET_SERVICE:
            return {...state, service: action.service}
        case SET_POPUPTITLE:
            return {...state, title: action.title}
    }
} 

const Service = (props) => {
    const [data, setData] = useState([]);
    const { userState } = useContext(AuthContext);
    const [modalShow, setModalShow] = useState(false);
 
    const [state, dispature] = useReducer(reducer, initialValue);

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };

    useEffect(() => {
        loadGrid();
    }, []);

    const loadGrid = () => {
        axios.get(apiRoutes.GetAllService, options)
        .then((response) => {
            if (response.status === 200) {
                const data = response.data;
                setData(data);
            }
        }, (error) => {
            console.log(error);
        });
    }
    
    const handleSubmit = () => {
        axios.post(apiRoutes.UpsertService, JSON.stringify(state.service), options)
        .then((response) => {
            if(response.status === 200)
            {
                setModalShow(false)
                alertify.success("Service added/updated successfully");
                
                loadGrid();
            }
        }, (error) => {
            console.log(error);
        });
    }

    const handleDelete = (id) => {
        console.log(id);

        alertify.confirm("Warning!", "Are you sure want to delete?",
        function(){
            axios.post(apiRoutes.DeleteService, JSON.stringify({id: id}), options)
            .then((response) => {
                alertify.success("Service deleted successfully");
                loadGrid();
            }, (error) => {
                console.log(error.response);
            });
        },
        function(){
          
        });
    }

    const OpenModel = (id) => {
        var selectedService = {};
        if(id == 0)
        {
            selectedService = {
                serviceId: 0,
                name: "",
                cost: 0,
                description: ''
            }
            dispature({type: SET_POPUPTITLE, title: "Add Service"})
    
        }
        else
        {
            selectedService = data.filter((item) => {
                return item.serviceId == id
            })[0]

            dispature({type: SET_POPUPTITLE, title: "Update Service"})
     
        }
        console.log(selectedService);
        dispature({type: SET_SERVICE, service: selectedService})
        setModalShow(true);
    }

    const columns = [
        {
            name: 'Service',
            selector: 'name',
            sortable: true
        },
        {
            name: 'Description',
            selector: 'description',
            sortable: true
        },
        {
            name: 'Cost',
            selector: 'cost',
            sortable: true
        },
        {
            name: 'Actions',
            sortable: true,
            cell: row => <div className="actions">
                            <a className="btn btn-sm bg-success-light" data-toggle="modal" onClick={() => OpenModel(row.serviceId)} >
                                <i className="fe fe-pencil"></i> Edit
                            </a>
                            <a data-toggle="modal" href="#delete_modal" className="btn btn-sm bg-danger-light" onClick={e => handleDelete(row.serviceId)}>
                                <i className="fe fe-trash"></i> Delete
                            </a>
                        </div>
        }
    ];

    return (  
        <div>
            <Breadcrumb title="Service"></Breadcrumb>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor='service' />
                        </div>
                        <div className="col-md-7 col-lg-8 col-xl-9">
                            <div className="row">
                                <div className="col-sm-12 col">
                                    
                                </div>
                                <div className="col-md-12">
                                    <div className="card">
                                        <div style={{paddingRight: "8px"}}>
                                            <a href="" data-toggle="modal" class="btn btn-primary float-right mt-2" onClick={() => OpenModel(0)}>Add</a>
                                        </div>
                                        <div className="card-body">
                                            <DataTable
                                                title="Services" 
                                                columns={columns}
                                                data={data}
                                                customStyles={customStyles}
                                                pagination
                                                highlightOnHover={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={modalShow}  onHide={() => setModalShow(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {state.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-body">
                        <form onSubmit={e => {e.preventDefault(); handleSubmit();}} >
                            <div className="row form-row">
                                <div className="col-12 col-sm-12">
                                    <div className="form-group">
                                        <label>Service</label>
                                        <input type="text" required className="form-control" value={state.service.name}  onChange={e => dispature({type: SET_SERVICE, service: {...state.service, name:  e.target.value}})}/>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12">
                                    <div className="form-group">
                                        <label>Description</label>
                                        <input type="text" required className="form-control" value={state.service.description}  onChange={e => dispature({type: SET_SERVICE, service: {...state.service, description:  e.target.value}})} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12">
                                    <div className="form-group">
                                        <label>Cost</label>
                                        <input type="number" required className="form-control" value={state.service.cost} onChange={e => dispature({type: SET_SERVICE, service: {...state.service, cost:  e.target.value}})} />
                                    </div>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary btn-block">Save Changes</button>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}
 
export default Service;